import { createAction, props } from '@ngrx/store';

export const updateTimecardSuccess = createAction(
    '[HUB CONNECTION SERVICE] Update Timecard Success',
    props<{ timecardId: number }>()
);
export const updateTimecardFailure = createAction(
    '[HUB CONNECTION SERVICE] Update Timecard Failure',
    props<{ timecardId?: number; error: string }>()
);

export const updateTimecardComplete = createAction(
    '[TIMECARD] Update Timecard Complete',
    props<{ timecardId: number }>()
);

export const loadComponent = createAction('[TIMECARD COMPONENT] Loading component');
export const destroyComponent = createAction('[TIMECARD COMPONENT] Destroying component');
